<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import { frontendUrl } from '@/config';
import languageToSlug from '@/helpers/languageToSlug';
import AddEditForm from '@/components/events/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';

export default {
    page: {
        title: 'Manage Event'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            name: {
                required
            },
            status: {
                required
            },
            date: {
                required
            }
        },
        language: {
            id: {
                required
            }
        }
    },

    data() {
        return {
            backRoute: '/events',
            indexName: 'Events',
            singleItemName: 'event',
            languagePicker: true,
            item: {
                language: null,
                status: 'published'
            }
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        },

        previewUrl() {
            const { externalLink, articleId, language } = this.item;

            const languageSlug = languageToSlug(language);

            const url = frontendUrl.concat(languageSlug);

            return externalLink || url.concat(`${`/articles/${articleId}`}`);
        }
    },

    methods: {
        ...mapActions({
            addItem: 'events/store',
            deleteItem: 'events/destroy',
            getItem: 'events/show',
            updateItem: 'events/update'
        })
    }
};
</script>
